// extracted by mini-css-extract-plugin
module.exports = {"Heading":"LogpointHeading_Heading__8cNGr","Label":"LogpointHeading_Label__zGxa_"};